var map = {
	"./1x1.svg": 20806,
	"./1x2.svg": 66594,
	"./2x2.svg": 17086,
	"./add.svg": 81072,
	"./alert-bell.svg": 45513,
	"./angle.svg": 67457,
	"./area.svg": 49126,
	"./arrow-down.svg": 49830,
	"./arrow-left.svg": 25537,
	"./arrow-right.svg": 80068,
	"./arrow-top-left.svg": 25722,
	"./arrow-top-right.svg": 21262,
	"./arrow-up.svg": 91239,
	"./ascending.svg": 24665,
	"./bell.svg": 79787,
	"./bill-glyph-16.svg": 84354,
	"./bill.svg": 83766,
	"./both-eyes.svg": 3452,
	"./bpm.svg": 69704,
	"./building.svg": 95811,
	"./calendar.svg": 95703,
	"./chart-primary.svg": 94069,
	"./check-glyph.svg": 34180,
	"./check-square.svg": 93421,
	"./check.svg": 69252,
	"./chevron-down.svg": 89710,
	"./chevron-left.svg": 60800,
	"./chevron-right.svg": 95912,
	"./chevron-up.svg": 37097,
	"./circuit.svg": 44306,
	"./close.svg": 79432,
	"./cloud-error.svg": 13553,
	"./cog.svg": 41855,
	"./compare.svg": 62056,
	"./crossroad.svg": 49344,
	"./delete.svg": 40074,
	"./descending.svg": 12471,
	"./directions.svg": 27819,
	"./download.svg": 26045,
	"./edit.svg": 8373,
	"./export.svg": 5835,
	"./filter.svg": 59192,
	"./group.svg": 96067,
	"./halt.svg": 99245,
	"./inadequate.svg": 25456,
	"./info-glyph-32.svg": 10739,
	"./info.svg": 16104,
	"./left-arrow.svg": 29865,
	"./left-eye.svg": 81093,
	"./lens-unavailable.svg": 22090,
	"./link.svg": 34228,
	"./loader.svg": 83532,
	"./loading-spinner-large.svg": 55751,
	"./loading-spinner-small.svg": 26136,
	"./loading.svg": 6265,
	"./lock-2.svg": 36941,
	"./lock.svg": 80785,
	"./lungs.svg": 8978,
	"./maintenance.svg": 8287,
	"./minus.svg": 63863,
	"./more.svg": 36485,
	"./multidot.svg": 91645,
	"./myopia.svg": 94849,
	"./nhs-logo.svg": 38396,
	"./no-roles.svg": 4317,
	"./note.svg": 64736,
	"./org-unit.svg": 18064,
	"./outcome.svg": 45736,
	"./pen.svg": 13454,
	"./pin.svg": 43175,
	"./play.svg": 24841,
	"./preferences1.svg": 40332,
	"./primary-vector.svg": 86757,
	"./refresh.svg": 70833,
	"./reload.svg": 58176,
	"./right-arrow.svg": 964,
	"./right-eye.svg": 1838,
	"./right-vector-arrow.svg": 56926,
	"./search.svg": 61677,
	"./section.svg": 10481,
	"./signout.svg": 80337,
	"./sortable.svg": 78464,
	"./support.svg": 4837,
	"./text.svg": 48645,
	"./tick.svg": 55153,
	"./trash.svg": 88835,
	"./undo.svg": 78856,
	"./user-glyph-32.svg": 68284,
	"./user.svg": 1916,
	"./users-multiple.svg": 98357,
	"./warning.svg": 43247,
	"./workstation.svg": 78017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6189;